import React, { useEffect } from "react";
import ContactUs, { ContactFromPros } from "../components/contact/ContactUs";
import generateConfig from "../util/config";
import { getInitialState } from "../components/contact/contactInfo";
import { useApiCall } from "../util/ApiCall";

const config = generateConfig();

export default function Contact({ formInitialData }: ContactFromPros) {
  const { refreshToken } = useApiCall();

  useEffect(() => {
    refreshToken({ forceSign: false });
  }, []);

  return <ContactUs formInitialData={formInitialData} />;
}

export async function getServerSideProps() {
  const metaTags = {
    title: `Contact Us | ${config.siteName || ""} - Get in Touch with Us Today`,
    description: `Reach out to ${
      config.siteName || "Krushna Raut"
    }, an experienced full-stack developer, to discuss new projects, collaborations, or consulting opportunities.`,
    keywords:
      "contact Krushna Raut, project inquiry, collaboration, experienced full-stack developer, portfolio contact",
    img: "/social-card.svg",
  };

  const initialData = getInitialState();

  return {
    props: {
      metaTags,
      formInitialData: initialData,
    },
  };
}
